import { render } from "./SearchIcon.vue?vue&type=template&id=0d5f22e2"
const script = {}

import exportComponent from "/home/eray/coding_stuff/toyhouse_raffle_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__